import script from "./InfoConductor.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoConductor.vue?vue&type=script&setup=true&lang=ts"

import "./InfoConductor.vue?vue&type=style&index=0&id=130a227f&lang=scss"

const __exports__ = script;

export default __exports__